<div class="unavailable">
  <p>
    <span>{{ categoryName }}</span> {{ 'CAT_NOT_AVAILABLE_ATM' | translate }}
  </p>
  <p *ngIf="dayName && toTime">
    {{ 'AVAILABLE_ON' | translate:{date:  dayName.toLowerCase()} }} {{ 'FROM' | translate:{time: toTime} }}
  </p>
</div>
